class Url {
  static getUrl () {
    const host = window.location.host
    const protocol = window.location.protocol
    let ip, port, url
    if (host.indexOf(':') > -1) {
      ip = host.split(':')[0]
      port = host.split(':')[1]
    } else {
      ip = host
      port = ''
    }
    if (window.location.hostname.indexOf('localhost') < 0 && window.location.hostname.indexOf('127.0.0.1') < 0) {
      if (port === '') {
        url = protocol + '//' + ip
      } else {
        url = protocol + '//' + ip + ':' + port
      }
    } else {
      url = process.env.AXIOS_URL
    }
    console.log(url)
    return url
  }
}

export default Url



// WEBPACK FOOTER //
// ./src/util/url.js